export default __webpack_public_path__ + "static/media/folder-favorite 1.478a68e2.svg";